"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Represents a course enrollment
 * @param {Object} enrollment object
 * @param {string} enrollment.userId
 * @param {string} enrollment.courseId id of the course the user is enrolled in
 * @param {timestamp} enrollment.timeEnrolled
 * @param {string} enrollment.subscriptionTier course subscription tier
 */


var CourseEnrollment = function CourseEnrollment(fields) {
  (0, _classCallCheck3.default)(this, CourseEnrollment);

  if (!fields) {
    return;
  }

  (0, _assign2.default)(this, fields);
};

exports.default = CourseEnrollment;